var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC1LogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 479.4597,
    height: 474.3542,
    viewBox: "0 0 479.4597 474.3542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#1d1f39;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 122.8017,
    y1: 675.8944,
    x2: 123.095,
    y2: 332.8575,
    gradientTransform: "matrix(1, 0, 0, -1, 298.3121, 793.6033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e323ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7517f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 154.0243,
    y1: 735.3132,
    x2: 154.0243,
    y2: 278.2531,
    gradientTransform: "matrix(1, 0, 0, -1, 298.3121, 793.6033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dffdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4da1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -29.7937,
    y1: 735.5097,
    x2: -29.395,
    y2: 270.7048,
    gradientTransform: "matrix(1, 0, 0, -1, 298.3121, 793.6033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7d05"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M421.2216,469.5162A175.9023,175.9023,0,0,1,296.8745,169.233a16.9144,16.9144,0,0,1,23.9219,23.9192,142.0883,142.0883,0,1,0,100.472-41.617,16.9133,16.9133,0,1,1,0-33.8265,175.9038,175.9038,0,1,1-.0468,351.8075Z",
    transform: "translate(-181.715 -58.29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425.0873,532.6442a235.6458,235.6458,0,0,1-177.391-80.4177,16.9126,16.9126,0,1,1,25.43-22.3033A202.875,202.875,0,1,0,424.9689,92.1165a16.9133,16.9133,0,1,1,0-33.8265A235.9772,235.9772,0,0,1,623.427,166.8456,237.1406,237.1406,0,0,1,459.9929,530.0373,234.5358,234.5358,0,0,1,425.0873,532.6442Z",
    transform: "translate(-181.715 -58.29)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.4838,392.0762a16.9154,16.9154,0,0,1-15.7791-10.8226A237.261,237.261,0,0,1,332.4959,74.3485a16.9132,16.9132,0,0,1,12.2775,31.52,203.82,203.82,0,0,0-115.516,263.1959,16.9207,16.9207,0,0,1-15.7736,23.0121Z",
    transform: "translate(-181.715 -58.29)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Group_3",
    "data-name": "Group 3",
    className: "cls-4",
    d: "M340.11,238.059a100.0387,100.0387,0,0,1,42.29-36.6315c9.7138-4.25,18.8208-.6129,23.0725,8.0953a16.4487,16.4487,0,0,1-8.1452,21.7893q-.0758.0345-.1518.0683c-23.2758,10.9287-39.4664,34.203-39.4664,60.9111a67.0611,67.0611,0,0,0,39.4648,60.9174,16.9209,16.9209,0,0,1,8.7021,22.0593c-3.6435,8.702-13.5589,12.1422-22.2625,8.702a100.5232,100.5232,0,0,1-43.1068-36.4344c-10.9288-16.3814-16.1906-35-16.1906-55.44A98.0124,98.0124,0,0,1,340.11,238.059Zm111.311,114.9529a71.01,71.01,0,0,0,20.028-13.5589,16.7442,16.7442,0,0,1,24.0993,23.2529q-.207.2145-.4216.4216a102.7757,102.7757,0,0,1-29.9513,20.641,16.7771,16.7771,0,0,1-22.162-8.4725q-.051-.1144-.1005-.23a16.4908,16.4908,0,0,1,8.0912-21.873q.2034-.0936.4091-.1815Zm13.5511-152.1973a117.9028,117.9028,0,0,1,28.1312,19.2336c4.6551,4.25,6.88,8.702,6.88,13.3572a16.8881,16.8881,0,0,1-28.5361,11.9405,65.51,65.51,0,0,0-20.0358-13.964,16.7253,16.7253,0,0,1,13.2289-30.71Q464.8075,200.7414,464.9725,200.8146Z",
    transform: "translate(-181.715 -58.29)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC1LogoDark);
export default __webpack_public_path__ + "static/media/c1-logo-dark.f6f9fd877ca564bab9aa42d60bd106e7.svg";
export { ForwardRef as ReactComponent };